<template>
  <div class="el-pagination el-pagination--has-no-pager">
    <button
      type="button"
      class="btn-prev"
      :class="{ disabled: !prevPageUrl || isLoading }"
      :disabled="!prevPageUrl || isLoading"
      @click="decreasePageNumber"
    >
      <i class="el-icon el-icon-arrow-left" />
    </button>
    <button
      type="button"
      class="btn-next"
      :class="{ disabled: !nextPageUrl || isLoading }"
      :disabled="!nextPageUrl || isLoading"
      @click="increasePageNumber"
    >
      <i class="el-icon el-icon-arrow-right" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'TransactionsPagination',

  props: {
    prevPageUrl: {
      type: String,
      default: '',
    },
    nextPageUrl: {
      type: String,
      default: '',
    },
    isLoading: Boolean,
  },

  data() {
    return {
      currentPage: 1,
    };
  },

  methods: {
    increasePageNumber() {
      this.currentPage += 1;
      this.$emit('change', this.currentPage);
    },

    decreasePageNumber() {
      this.currentPage -= 1;
      this.$emit('change', this.currentPage);
    },
  },
};
</script>
